




import {Component, Prop, Vue} from 'vue-property-decorator';
import EditDialog from './EquipmentEditDialog.vue';
import equipmentConfigCategory from '@/enums/EquipmentCategoryEnum';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
})
export default class Equipment extends Vue {
    @Prop() data!: any;
    @Prop() equipmentCategory!: any;
    private editDialog = EditDialog;

    get requestApi() {
        if (this.equipmentCategory === equipmentConfigCategory.VeneerProductionEquipment)
            return this.$api.catalogues.veneerProductionEquipment;
        else return this.$api.catalogues.veneerProcessingEquipment;
    }
}
